import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  DimensionScopeSection,
  DimensionScopeThreeSection
} from "../../../../EmissionsReports/components/ByDimensionReport/components";
import {
  getFilledCategoriesArray
} from "../../../../EmissionsReports/components/ByDimensionReport/components/DimensionScopeSection";

function ConsumptionsByDimensionModal({ modalTitle, dimensionData, isOpen, onClose }) {
  const { t } = useTranslation("translation");

  const allManual = dimensionData?.manualEmissions ?? [];
  const scope1Manual = allManual.filter(m => m.scopeCategoryKey === "SCOPE_1");
  const scope2Manual = allManual.filter(m => m.scopeCategoryKey === "SCOPE_2");
  const scope3Manual = allManual.filter(m => m.scopeCategoryKey !== "SCOPE_1" && m.scopeCategoryKey !== "SCOPE_2");

  const hasNoData = () => {
    return (
      getFilledCategoriesArray(dimensionData?.directEmissions).length === 0 &&
      getFilledCategoriesArray(dimensionData?.indirectEmissions).length === 0 &&
      dimensionData?.scopeThreeEmissions?.scopeThreeTotalCo2Emissions === 0 &&
      allManual.length === 0
    );
  };

  return isOpen ? <Modal isOpen={isOpen} onClose={onClose} size="6xl">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>{modalTitle} Consumptions Data</ModalHeader>
      <ModalCloseButton />

      <ModalBody>
        {dimensionData &&
          <>
            <DimensionScopeSection
              title={t("reportsPage.scope1Title")}
              data={dimensionData.directEmissions}
              manualEmissions={scope1Manual}
              hasOtherData={!hasNoData()}
            />
            <DimensionScopeSection
              title={t("reportsPage.scope2Title")}
              data={dimensionData.indirectEmissions}
              manualEmissions={scope2Manual}
              hasOtherData={!hasNoData()}
            />
            <DimensionScopeThreeSection
              data={dimensionData.scopeThreeEmissions}
              manualEmissions={scope3Manual}
              hasOtherData={!hasNoData()}
            />
          </>
        }
      </ModalBody>

      <ModalFooter>
        <Button variant="ghost" mr={3} onClick={onClose}>
          {t("buttons.close")}
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal> : null;
}

export default ConsumptionsByDimensionModal;